export default "__VITE_ASSET___tF31M3K__"